import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Every route - we lazy load so that each page can be chunked
// NOTE that some of these chunks are very small. We should optimize
// which pages are lazy loaded in the future.
import LoadingIndicator from './pages/LoadingIndicator';
const Verse = lazy(() => import('./pages/Verse'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Placeholder = lazy(() => import('./pages/Placeholder'));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          <Route path="/verse/:mood" element={<Verse />} />
          <Route path="/verse" element={<Verse />} />
          <Route path="/" element={<Placeholder />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;